<template>
  <div>
    <device-management-pc class="pc-show" :init-data="initData" :hasFetch="hasFetch" @showDeleteModal='showDeleteModal' @showModifyModal='showModifyModal'></device-management-pc>
    <device-management-m class="phone-show" :init-data="initData" :hasFetch="hasFetch" @showDeleteModal='showDeleteModal' @showModifyModal='showModifyModal'></device-management-m>

    <div class="modal fade text-center" id="delete-device-modal" tabindex="-1" role="dialog"
       aria-labelledby="myModalLabel" backdrop="static" keyboard="false">
      <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div>{{$tc('delete_tips', 1)}}</div>
            <div>{{$tc('delete_tips', 2)}}</div>
          </div>
          <div class="modal-footer">
            <button class='ok-btn' @click='deleteDevice'><span>{{$t('ok_btn')}}</span></button>
            <button class='no-btn' @click='addDevice'><span>{{$t('no_btn')}}</span></button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade text-center" id="modify-device-modal" tabindex="-1" role="dialog"
       aria-labelledby="myModalLabel" backdrop="static" keyboard="false">
      <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div>{{$t('modify_tips')}}</div>
            <input id="device-input" :class='{"input-color": modifyColor}' type="text" :value="deviceRename" @blur='modifyInputCount' @focus='modifyInputColor'>
          </div>
          <div class="modal-footer">
            <button class='ok-btn' @click='modifyDevice'><span>{{$t('modify_confirm')}}</span></button>
            <button class='no-btn' @click='closeModal'><span>{{$t('modify_cancel')}}</span></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import deviceManagementPc from '../../components/deviceManagement/DeviceManagementPC.vue'
  import deviceManagementM from '../../components/deviceManagement/DeviceManagementM.vue'
  import locales from './lang'

  export default {
    name: 'device-management-view',
    components: {
      deviceManagementPc,
      deviceManagementM
    },
    locales,
    data() {
      return {
        initData: '',
        deleteId: '',
        modifyId: '',
        deviceRename: '',
        hasFetch: false,
        modifyColor: false
      }
    },
    created() {
      this.getInitRecordsData()
    },
    methods: {
      getInitRecordsData() {
        this.$http.get('api/active-devices').then((response) => {
          this.initData = response
          this.hasFetch = true
        })
      },
      showDeleteModal(id) {
        $('#delete-device-modal').modal('show')
        this.deleteId = id
      },
      showModifyModal(id, name) {
        $('#modify-device-modal').modal('show')
        this.modifyId = id
        this.deviceRename = name
      },
      closeModal() {
        $('#modify-device-modal').modal('hide')
      },
      modifyInputColor() {
        this.modifyColor = true
      },
      modifyInputCount() {
        this.modifyColor = false
        this.deviceRename = document.getElementById('device-input').value
      },
      deleteDevice() {
        $('#delete-device-modal').modal('hide')
        this.$toast(this.$t('disconnect_tips'))
        this.$http.post('api/disconnect-active-device', {
          device_id: this.deleteId
        }).then((response) => {
          this.getInitRecordsData()
        }, (response) => {
          this.$toast(response.body.message)
        })
      },
      modifyDevice() {
        if (this.deviceRename.length >= 0 && this.deviceRename.length <= 20) {
          this.$http.post('api/rename-device', {
            device_id: this.modifyId,
            device_name: this.deviceRename
          }).then((response) => {
            this.closeModal()
            this.$toast(response.body.message)
            this.getInitRecordsData()
          }, (response) => {
            this.$toast(response.body.message)
          })
        } else {
          this.$toast(this.$t('modify_length_over'))
        }
      },
      addDevice() {
        $('#delete-device-modal').modal('hide')
        setTimeout(() => {
          this.$router.push('/dashboard')
        }, 300)
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../assets/scss/variables";
  @import "../../assets/scss/reset-modal";

  * {
    padding: 0;
    margin: 0;
  }

  #delete-device-modal, #modify-device-modal {
    .modal-dialog {
      width: 295px;
      top: 41%;
      left: 50%;
      transform: translate(-50%, -50%);
      .modal-content {
        height: auto;
        background: #fff;
        border: 1px solid #E0D7E3;
        padding: 24px;
        .modal-header{
          min-height: .3rem;
        }
        .modal-header .close {
          display:block;
          width: 24px;
          height: 24px;
          font-size: 30px;
          color: #666;
          margin-top:-18px;
          position:relative;
          left: 13px;
          text-shadow: none;
          font-weight: 400;
        }
      }
      .modal-body {
        font-size: .2rem;
        color:#111;
        line-height: 30px;
      }
      .modal-footer {
        text-align: center;
        .ok-btn, .no-btn {
          display: block;
          margin: 0 auto;
          font-size: .16rem;
          box-sizing: border-box;
          cursor: pointer;
        }
        .ok-btn {
          margin-top: .64rem;
          width: 180px;
          height: 40px;
          line-height: 40px;
          background: #F76B4C;
          color: #FFFFFF;
          font-weight: 600;
          border-radius: 20px;
        }
        .no-btn {
          margin: .24rem auto 0;
          font-size: .16rem;
          color:#333;
          background:transparent;
        }
      }
      @media screen and (max-width:767px) {
        top: 28.5%;
        left: calc(50% - 295px/2);
        transform: none;
        .modal-footer {
          .ok-btn {
            margin-top: .48rem;
          }
        }
      }
    }
  }
  #modify-device-modal {
    .modal-dialog {
      width: 295px;
      .modal-body {
        font-size: .2rem;
        color: #333333;
        input {
          width: 231px;
          font-size: .14rem;
          color: #CCCCCC;
          margin-top: 0.44rem;
          padding-bottom: 0.04rem;
          line-height: 0.2rem;
          text-align: center;
          outline: 0;
          background:transparent;
          border-bottom: 1px solid rgba(224,215,227,.6);
        }
        .input-color {
          color:  #333333;
        }
      }
      .modal-footer {
        text-align: center;
        .ok-btn, .no-btn {
          padding: 0 .3rem;
        }
        .ok-btn {
          font-size: .16rem;
          width: 180px;
          height: 40px;
          line-height: 40px;
          color: #416CF8;
          border: 1px solid rgba(65,108,248,1);
          border-radius: 20px;
          margin-top: 0.45rem;
          background: #fff;
        }
        .no-btn {
          font-size: .17rem;
          border: 0;
          margin-bottom: 0;
          color: #333;
        }
      }
    }
  }

  @media screen and (min-width: 768px) {
    .phone-show {
      display: none;
    }
  }

  @media screen and (max-width: 767px) {
    .pc-show {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// deviceManagement.vue?7537bdda